import React from 'react'
/* eslint-disable import/no-unresolved */
import Grid from '@material-ui/core/Grid'
import Skeleton from '@material-ui/lab/Skeleton'
import YouTubeIcon from '@material-ui/icons/YouTube'
import CardBody from '../../sharedComponents/Card/CardBody'
import Card from '../../sharedComponents/Card/Card'
import { useStyles } from './styles'
import VideoCardList from '../VideoCardList'

const VideoListInside = ({
  videos,
  loading,
  handleFeelingsById,
  handleDeleteVideoList,
  handleCommetsByVideoId,
}) => {
  const classes = useStyles()
  return (
    <Card>
      <CardBody>
        <Grid
          component="div"
          className={classes.gridList}
          container
          spacing={2}
        >
          {!loading ? (
            Array.isArray(videos) && videos.length > 0 ? (
              videos.map((video) => (
                <VideoCardList
                  key={video.videoId}
                  video={video}
                  handleFeelingsById={handleFeelingsById}
                  handleCommetsByVideoId={handleCommetsByVideoId}
                  handleDeleteVideoList={handleDeleteVideoList}
                />
              ))
            ) : (
              <div className={classes.center}>
                <p> Búsca y añade un video </p>{' '}
                <YouTubeIcon style={{ color: '#F70000' }} alt="Ver Video - " />
              </div>
            )
          ) : (
            <>
              {[1, 2, 3, 4, 5].map((value) => (
                <React.Fragment key={value}>
                  <div className={classes.containerImage}>
                    <Skeleton
                      animation="wave"
                      variant="rect"
                      width={480}
                      height={360}
                    />
                  </div>
                  <div className={classes.cardBodyList}>
                    {[4, 6, 8, 10, 70].map((item, index) => (
                      <div key={item}>
                        <Skeleton
                          animation="wave"
                          variant="text"
                          height={item * index}
                        />
                      </div>
                    ))}
                  </div>
                </React.Fragment>
              ))}
            </>
          )}
        </Grid>
      </CardBody>
    </Card>
  )
}

export default VideoListInside
